import type { RouteObject } from 'react-router-dom'
import { Outlet } from 'react-router-dom'

import EditContext from '@app/pages/maps/editContext'
import Show from '@app/pages/maps/show'

const routes: RouteObject = {
  path: 'maps',
  element: <Outlet />,
  children: [
    {
      index: true,
      element: <Show />
    },
    {
      path: 'edit-context',
      element: <EditContext />
    },
    {
      path: ':businessContextId',
      element: <Show />,
      children: [
        {
          path: 'edit-context',
          element: <EditContext />
        }
      ]
    }
  ]
}

export default routes
